import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FlexContainer, Text, Wrapper } from './TogglersEntity.styles';
import {
  AgreementSign,
  HistoricalSign,
} from '../ReportLayout/SharedEffectReportComponents/EffectReportTemplate/ReportTimestemps/TimestampSigns/TimestampSigns';
import Toggler from '../Toggler/Toggler';

interface TogglersEntityProps {
  handleToggleState: (name: 'historical_result' | 'agreement') => void;
  isHistoricalResults: boolean;
}

const TogglersEntity: FC<TogglersEntityProps> = ({ handleToggleState, isHistoricalResults }) => {
  const { t } = useTranslation();
  return (
    <Wrapper>
      {isHistoricalResults && (
        <FlexContainer>
          <HistoricalSign />
          <Text>{t('report.effect.timestamps.historicalResults')}</Text>
          <Toggler name="historical_result" handleToggleState={handleToggleState} />
        </FlexContainer>
      )}

      <FlexContainer>
        <AgreementSign />
        <Text>{t('report.effect.timestamps.agreements')}</Text>
        <Toggler name="agreement" handleToggleState={handleToggleState} />
      </FlexContainer>
    </Wrapper>
  );
};

export default TogglersEntity;
